const projectPath = '/enrolamiento-3/';
const fullProjectPath = `/enrolamiento-3${window.location.pathname}`;
const dataLayerObject = {

  // PASO 1
  PERSONAL_DATA_LOADED: {
    event: 'vpv',
    page: `/enrolamiento-cv/datos-personales/validar-ci`,
  },
  PERSONAL_DATA_CEDULE_VERIFICATION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/datos-personales/validar-ci`,
      'eve-cat': 'Click',
      'eve-lab': 'verificar mi cedula',
    },
  },
  PERSONAL_DATA_VERIFIED_CEDULE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/datos-personales`,
      'eve-cat': 'Notificacion',
      'eve-lab': 'cedula validada con exito',
    },
  },
  PERSONAL_DATA_SELECTED_BRANCH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Notificacion',
      'eve-lab': 'Sucursal - %comuna%'
    }
  },
  PERSONAL_DATA_EXECUTIVE_CODE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Notificacion',
      'eve-lab': '%codigo-ejecutivo%'
    }
  },
  PERSONAL_DATA_TO_STEP_2_BUTTON: {
    'event': 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton%'
    }
  },

  PERSONAL_DATA_TO_BIOMETRY: {
    event: 'vpv',
    page: '/enrolamiento-cv/biometria/inicio',
  },

  PERSONAL_DATA_CEDULA_PHOTO: {
    'event': 'vpv',
    'page': '/enrolamiento-cv/biometria/cedula'
  },

  PERSONAL_DATA_SELFIE: {
    'event': 'vpv',
    'page': '/enrolamiento-cv/biometria/selfie'
  },

  PERSONAL_BIOMETRY_SUCCESS: {
    'event': 'vpv',
    'page': '/enrolamiento-cv/biometria/exito'
  },
  /**
   * PASO 2 NO, POR EL MOMENTO
   */

  // PASO 3
  CONTRATING_PAYMENT_LOADED: {
    event: 'vpv',
    page: `/enrolamiento-cv/contratacion-pago`,
  },
  CONTRATING_PAYMENT_TO_FINAL_STEP_BUTTON: {
    'event': 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/contratacion-pago',
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton%'
    }
  },

  // PASO FINAL
  SUMMARY_LOADED: {
    event: 'vpv',
    page: `/enrolamiento-cv/comprobante`,
    cuotas: '%cantidad-cuotas%', //BORRAR LOS OTROS CAMPOS
  },
  SUMMARY_CLIK_OPTION_DIGITIZE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton%',
    },
  },
  SUMMARY_CREATE_PASSWORD: { //duda
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton%',
    },
  },


  // BORDES
  BORDE_RECENT_FORMER_PARTNER: {
    'event': 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Renuncia reciente'
    }
  },
  BORDE_UNDERAGE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Mayor de edad',
    },
  },
  BORDE_LEGAL_PERSON: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Persona juridica',
    },
  },
  BORDE_GENERIC_ERROR_EXIT_FLOW: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Antecedentes adicionales',
    },
  },
  BORDE_RESTRICTED_HOURS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Cierre Bancario',
    },
  },
  BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDED_IDENTITY: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Intentos permitidos',
    },
  },
  BORDE_ALREADY_MEMBER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Ya tiene cuenta vista',
    },
  },
  BORDE_DIFFERENT_CHILE_TAX_PAYMENT: {
    'event': 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Error',
      'eve-lab': 'Estadounidense'
    }
  },
  BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDEDD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/biometria`,
      'eve-cat': 'Error',
      'eve-lab': 'Intentos permitidos',
    },
  },
  BORDE_IDENTITY_FACIAL_BIOMETRY_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/biometria`,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error',
    },
  },
  BORDE_IDENTITY_VALIDATION_NOT_AVAILABLE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/biometria`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave unica no disponible',
    },
  },
  BORDE_IDENTITY_VALIDATION_OFFICE_REDIRECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/biometria`,
      'eve-cat': 'Error',
      'eve-lab': 'Medio no disponible',
    },
  },
  BORDE_SEND_SMS_TIME_OVER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave dinamica - tiempo agotado',
    },
  },
  BORDE_SEND_SMS_INCORRET_CODE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave dinamica - incorrecta',
    },
  },
  BORDE_SEND_SMS_LOCKED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave dinamica - intentos',
    },
  },
  BORDE_SIGNATURE_REQUEST_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Firma',
    },
  },
  BORDE_DECLINED_PAYMENT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Pago',
    },
  },

  //----------------------------------------------------------------------------

  // PERSONAL_DATA_TO_STEP_2_BUTTON
  // PERSONAL_DATA_CONTINUE: {
  //   event: 'trigger_event',
  //   'event-config': {
  //     'eve-acc': `${projectPath}paso1/datos-personales`,
  //     'eve-cat': 'Click',
  //     'eve-lab': 'Continuar',
  //   },
  // },
  // PERSONAL_DATA_CANCEL: {
  //   event: 'trigger_event',
  //   'event-config': {
  //     'eve-acc': `${projectPath}paso1/datos-personales`,
  //     'eve-cat': 'Click',
  //     'eve-lab': 'Cancelar',
  //   },
  // },

  CONTRATING_PAYMENT_DOWNLOAD_CONTRACT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': '%nombre-documento%',
    },
  },
  // CONTRATING_PAYMENT_SEND_SMS: {
  //   event: 'trigger_event',
  //   'event-config': {
  //     'eve-acc': `${projectPath}paso2/contratacion-pago`,
  //     'eve-cat': 'Click',
  //     'eve-lab': 'Enviar clave por SMS',
  //   },
  // },
  CONTRATING_PAYMENT_CONTINUE: {
    event: 'trigger_event',
    producto: '%envio%',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': 'Ir al pago',
    },
  },
  CONTRATING_PAYMENT_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': 'Cancelar',
    },
  },

  BORDE_WP_CONECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Inconvenientes para conectar con Webpay',
    },
  },
  BORDE_WP_CONECTION_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Inconvenientes para conectar con Webpay - Reintentar',
    },
  },

  BORDE_CANCELED_PAYMENT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Has anulado tu pago',
    },
  },






  SUMMARY_CLOSE_MODAL_SUCCESSFULL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/pago-exitoso`,
      'eve-cat': 'Click',
      'eve-lab': 'Entendido, continuar',
    },
  },

  SUMMARY_SHOW_DETAILS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Ver detalle',
    },
  },

  SUMMARY_BACK_TO_COOPEUCH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': 'Volver a Coopeuch',
    },
  },

  SURVEY_ABANDONMENT_LOAD: {
    event: 'vpv',
    page: `${projectPath}encuesta-abandono%paso%`,
  },
  SURVEY_ABANDONMENT_SENDING: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}encuesta-abandono%paso%`,
      'eve-cat': '%ubicacion%',
      'eve-lab': '%opcion-comentario%',
    },
  },
  SURVEY_ABANDONMENT_RETURN: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}encuesta-abandono%paso%`,
      'eve-cat': 'Click',
      'eve-lab': 'Retomar contratacion',
    },
  },
  SURVEY_ABANDONMENT_EXIT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}encuesta-abandono%paso%`,
      'eve-cat': 'Click',
      'eve-lab': 'Retomar contratacion',
    },
  },
  SURVEY_USABILITY_SATISFACTION_LOAD: {
    event: 'vpv',
    page: `${projectPath}paso3/comprobante-adicionales/encuesta-opinion`,
  },
  SURVEY_USABILITY_SATISFACTION_EXIT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales/encuesta-opinion`,
      'eve-cat': 'Click',
      'eve-lab': 'Volver a Coopeuch.cl',
    },
  },
  SURVEY_USABILITY_SATISFACTION_1: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales/encuesta-opinion1`,
      'eve-cat': 'Click',
      'eve-lab': '%puntuacion-comentario%',
    },
  },
  SURVEY_USABILITY_SATISFACTION_2: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales/encuesta-opinion2`,
      'eve-cat': 'Click',
      'eve-lab': '%puntuacion-comentario%',
    },
  },

  BORDE_NO_TAXES_IN_CHILE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'No paga impuestos en Chile',
    },
  },
  BORDE_NO_TAXES_IN_CHILE_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'No paga impuestos en Chile - Entendido',
    },
  },
  BORDE_BLACK_LIST: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Lista negra',
    },
  },
  BORDE_BLACK_LIST_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Lista negra - Entendido',
    },
  },

  BORDE_DECEASED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Fallecidos',
    },
  },
  BORDE_DECEASED_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Fallecidos - Entendido',
    },
  },

  BORDE_UNDERAGE_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Mayor de 18 años - Entendido',
    },
  },


  BORDE_LEGAL_PERSON_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'RUT corresponde a persona juridica - Entendido',
    },
  },

  BORDE_GENERIC_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error',
    },
  },
  BORDE_GENERIC_ERROR_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error - Entendido',
    },
  },
  BORDE_GENERIC_TRANSVERSE_STEP_2: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error',
    },
  },
  BORDE_GENERIC_TRANSVERSE_STEP_2_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error - Entendido',
    },
  },
  BORDE_GENERIC_ERROR_EXIT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': '%error%',
    },
  },
  BORDE_GENERIC_ERROR_EXIT_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': '%error% - Entendido',
    },
  },

  BORDE_GENERIC_ERROR_EXIT_FLOW_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Continuar ingreso en sucursal - Entendido',
    },
  },

  BORDE_ALREADY_MEMBER_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ya eres socio Coopeuch - Entendido',
    },
  },
  BORDE_ALREADY_MEMBER_ELECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  BORDE_CUSTOMER_WITH_UNPAID_FEES: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ya eres socio Coopeuch',
    },
  },
  BORDE_CUSTOMER_WITH_UNPAID_FEES_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ingreso Pendiente - Entendido',
    },
  },

  BORDE_RECENT_FORMER_PARTNER_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Tienes una renuncia vigente - entendido',
    },
  },
  BORDE_FOREIGN: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Contar con residencia definitiva',
    },
  },
  BORDE_FOREIGN_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Contar con residencia definitiva - Entendido',
    },
  },

  BORDE_RESTRICTED_HOURS_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Cierre Bancario - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Clave unica',
    },
  },
  BORDE_IDENTITY_VALIDATION_ERROR_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Clave unica - Entendido',
    },
  },

  BORDE_IDENTITY_VALIDATION_OFFICE_REDIRECTION_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Identidad no puede ser validada - Entendido',
    },
  },

  BORDE_IDENTITY_VALIDATION_NOT_AVAILABLE_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave unica no disponible - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_RETRY: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Reingresa con clave unica',
    },
  },
  BORDE_IDENTITY_VALIDATION_RETRY_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Reingresa con clave unica - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDED_ERROR_IDENTITY: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Intentos permitidos',
    },
  },
  BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDED_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Intentos permitidos - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_GET_QUESTIONS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Preguntas',
    },
  },
  BORDE_IDENTITY_VALIDATION_GET_QUESTIONS_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Preguntas - Entendido',
    },
  },

  BORDE_SENDING_OFFERS_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Error',
      'eve-lab': 'Error al enviar solicitud offer',
    },
  },

  BORDE_INPUT_ADDRESS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ingresar dirección con número',
    },
  },

  BORDE_INPUT_ADDRESS_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ingresar dirección con número - Entendido',
    },
  },

  SUMMARY_DOWNLOAD_SECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': 'Descargar %Nombre%',
    },
  },
  /* SUMMARY_GO_TO_PRODUCT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': '%nombre-producto%',
    },
  }, */



  SUMMARY_SELECT_STORE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Descarga %texto-boton%',
    },
  },

  /* SUMMARY_GO_DOWN_APPCOOPEUCH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%marketplace%',
    },
  }, */

  /* SUMMARY_SHOW_REQUEST_IN_PROGRESS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': 'Ver detalle de solicitud en curso',
    },
  }, */
  SUMMARY_REQUESTS_SMS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Enviar codigo por SMS',
    },
  },
  SUMMARY_SMS_LOCKED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Error',
      'eve-lab': 'Excedido limite de intentos - Clave',
    },
  },
  SUMMARY_VALIDATE_SMS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'validar y continuar SMS',
    },
  },

  SUMMARY_CREATE_PASSWORD_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Error',
      'eve-lab': 'Error al crear clave',
    },
  },


  CONTRACTS_HIRE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/contratacion`,
      'eve-cat': 'Click',
      'eve-lab': 'Contratar',
    },
  },
  CONTRACTS_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/contratacion`,
      'eve-cat': 'Click',
      'eve-lab': 'Cancelar',
    },
  },
  ADDITIONALS_LOADED: {
    event: 'vpv',
    page: `${projectPath}paso4/adicionales`,
    producto: '%oferta%',
  },
  ADDITIONALS_SELECT_OFFER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton% - Adicionales',
    },
  },
  ADDITIONALS_CONTINUE_WITH_OFFER_SELECTED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Continuar - %selected-offer%',
    },
  },
  ADDITIONALS_MODIFY_SELECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Modificar - %selected-offer%',
    },
  },
  ADDITIONALS_ACCEPTATION_OFFER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton-and-offer%',
    },
  },
  ADDITIONALS_SELECT_CAH_TYPE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%cah-type%',
    },
  },

  ADDITIONALS_OFFICE_SELECT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_OFFER_ACCEPTATION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_CONTRACT_CAH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Contratar y finalizar - Cuenta de Ahorro',
    },
  },
  ADDITIONALS_CONTINUE_SELECT_DRAWAL_OFFICE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_CONTINUE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_CONTINUE_WITHOUT_PRODUCTS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Mensaje',
      'eve-lab': 'Sin productos adicionales',
    },
  },
  ADDITIONALS_CONTINUE_WITHOUT_PRODUCTS_CLICK: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton% - sin productos adicionales',
    },
  },

  DELIVERY_RETIRO_OFFICE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': '/enrolamiento-cv/datos-personales',
      'eve-cat': 'Click',
      'eve-lab': '%despacho%'
    }
  },

  ADDITIONALS_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Volver a Coopeuch',
    },
  },

  SEND_SMS_HABILITADORES: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/comprobante/creacion-clave`,
      'eve-cat': 'Click',
      'eve-lab': 'Enviar código por SMS'
    },
  },

  CREATE_PASSWORD_HABILITADORES:{
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `/enrolamiento-cv/comprobante/creacion-clave`,
      'eve-cat': 'Click',
      'eve-lab': 'Crear y confirmar contraseña'
    },
  }
}



export default dataLayerObject;
